import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

import colors from 'assets/theme/base/colors';
// Soft UI Context Provider
import { ArgonControllerProvider } from 'context';

import { UserProvider } from 'context/userContext';
import { OrgProvider } from 'context/orgContext';
import { ProductProvider } from 'context/productContext';

// react-perfect-scrollbar styles
import 'react-perfect-scrollbar/dist/css/styles.css';
import { NotificationProvider } from 'context/NotificationContext';
import { VisibilityProvider } from 'context/visibilityContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ArgonControllerProvider>
      <UserProvider>
        <OrgProvider>
          <ProductProvider>
            <NotificationProvider>
              <VisibilityProvider>
                <App />
              </VisibilityProvider>
            </NotificationProvider>
          </ProductProvider>
        </OrgProvider>
      </UserProvider>
    </ArgonControllerProvider>
  </BrowserRouter>
);
